import { useState } from 'react';
import { Box, Typography } from '@mui/material';

import DefaultWrapper from 'shared-components/DefaultWrapper';
import {
  AboutFoundation,
  ChangePassword,
  CommunicationPreferences,
  Consent,
  Contacts,
  PersonalInformation,
  ProfilePicture,
  PulseSurvey,
  Modal as ConsentModal,
} from 'components/MyAccount';
import { PKDModal } from 'components/Modal';

const MyAccount = () => {
  const [openState, setOpenState] = useState(false);
  const [isOptingIn, setIsOptingIn] = useState(false);
  const [isPulseSurveyOpenModal, setIsPulseSurveyOpenModal] = useState(false);

  const handleIsPulseSurveyOpenModal = () => {
    setIsPulseSurveyOpenModal(!isPulseSurveyOpenModal);
  };

  const toggleIsOptingIn = (hasOptedIn) => {
    setIsOptingIn(hasOptedIn);
  };

  const handleConsentCTA = (status = false) => {
    setOpenState(status);
  };

  return (
    <DefaultWrapper
      crumbs={[{ title: 'My Account', isActive: true }]}
      showHeader={true}>
      <PKDModal
        isOpen={openState}
        onClose={() => {
          setOpenState(false);
        }}
        title='Consent'
        width='926px'>
        <ConsentModal />
      </PKDModal>
      <Box
        sx={{
          display       : 'flex',
          flexDirection : 'column',
          padding       : { xs: '15px', sm: '10px 0 10px 0' },
        }}>
        <Typography
          fontFamily='Montserrat' fontWeight='700' variant='h1'>
          My account
        </Typography>
        <Box
          sx={{
            display        : 'flex',
            flexDirection  : { xs: 'column', md: 'row' },
            justifyContent : { xs: 'space-around', xl: 'flex-start' },
          }}
          mt={2}
          gap={2}>
          <Box>
            <PersonalInformation
              setIsPulseSurveyOpenModal={setIsPulseSurveyOpenModal}
              isPulseSurveyOpenModal={isPulseSurveyOpenModal}
              toggleIsOptingIn={toggleIsOptingIn}
            />
            <ChangePassword />
            <AboutFoundation />
            <PulseSurvey
              isOptingIn={isOptingIn}
              handleIsPulseSurveyOpenModal={handleIsPulseSurveyOpenModal}
            />
          </Box>
          <Box>
            <ProfilePicture />
            <CommunicationPreferences />
            <Consent
              handleConsentModal={handleConsentCTA}
            />
            <Contacts />
          </Box>
        </Box>
      </Box>
    </DefaultWrapper>
  );
};

export default MyAccount;
